import { CalendarMode, Row } from "PFApp/booking/types";
import { RowType } from "PFApp/booking/types/row";
import { ProjectItem } from "PFCore/hooks/queries/bookings/projects/use_projects_entries";
import React, { JSX } from "react";

import { ActivityStatusBadge } from "../../../../audit_planner/parts/audit_role_status/activity_status_badge";
import { AuditRoleStatus } from "../../../../audit_planner/parts/audit_role_status/audit_role_status";
import { useBookingsOverviewContext } from "../context/bookings_overview_context";
import css from "../side_panel_rows.module.scss";

type RowBadgeProps = {
  row: Row;
};

export const RowBadge = ({ row }: RowBadgeProps): JSX.Element => {
  const { calendarMode } = useBookingsOverviewContext();
  const { type, original } = row;
  return (
    <>
      {type === RowType.Role && calendarMode === CalendarMode.Projects && (
        <div className={css.statusBadge}>
          <AuditRoleStatus role={(original as ProjectItem).activity} />
        </div>
      )}
      {type === RowType.Engagement && calendarMode === CalendarMode.Projects && (
        <div className={css.statusBadge}>
          {((original as ProjectItem).activity.state === "draft" ||
            (original as ProjectItem).activity.state === "complete") && (
            <ActivityStatusBadge status={(original as ProjectItem).activity.state} />
          )}
        </div>
      )}
    </>
  );
};
